'use es6';

import tinymce from 'tinymce';
import ReactDOM from 'react-dom';
import { compose } from 'rich-text-lib/utils/iterables';
import InlineToolbar from '../components/InlineToolbar';
import { getNamespace } from '../utils/namespace';
import { CANVAS_INLINE } from '../constants';
import { SHOW_TOOLBAR_SHEPHERD } from '../constants/toolbar';
import withToolbarSpace from '../components/withToolbarSpace';
import withFakeSelection from '../components/withFakeSelection';
import withPropagationOverride from '../components/withPropagationOverride';
import withPersistentToolbar from '../components/withPersistentToolbar';
import withTransientToolbar from '../components/withTransientToolbar';
import { registerIdleCallbacks } from './ui/canvas';
import { renderPopovers, handleMinHeight } from './ui/canvas';
import { jsx as _jsx } from "react/jsx-runtime";
export { CANVAS_INLINE };
function CanvasInlineTheme(editor) {
  let editorContainer;
  const settings = editor.settings;
  const inlineToolbarContainer = tinymce.DOM.select(settings.fixed_toolbar_container)[0];
  const namespace = getNamespace(editor);
  const useToolbar = !!settings.canvasToolbar;

  // Relies on function declaration hoisting.
  //
  // Persistent toolbar is inteneded to always be mounted in it's container
  // Transient toolbar shows and hides depending on editor state
  let Toolbar;
  if (useToolbar) {
    const withToolbarManager = settings.persistToolbar ? withPersistentToolbar(editor, renderToolbar, removeToolbar) // @typescript-eslint/no-use-before-define
    : withTransientToolbar(editor, renderToolbar, removeToolbar); // @typescript-eslint/no-use-before-define

    const hocs = [withToolbarManager, withFakeSelection, ...(settings.propagationOverride ? [withPropagationOverride(namespace)] : []), ...(settings.toolbarSpace ? [withToolbarSpace] : [])];
    Toolbar = compose(...hocs)(InlineToolbar);
  }
  const renderUI = () => {
    const targetNode = editor.getElement();
    if (!editorContainer) {
      editorContainer = document.createElement('div');
      editorContainer.id = `${editor.id}__editor-container`;
    }
    if (useToolbar) {
      inlineToolbarContainer.parentElement.appendChild(editorContainer);
    } else {
      targetNode.parentNode.appendChild(editorContainer);
    }
    renderPopovers(editor);
    registerIdleCallbacks(editor);
    handleMinHeight(editor);
    settings.content_editable = true;
    return {
      editorContainer
    };
  };
  if (!settings.inline) {
    throw new Error('[tinymce-themes] the inline-canvas theme only supports inline mode');
  }
  if (useToolbar && !settings.fixed_toolbar_container) {
    throw new Error('[tinymce-themes] the inline-canvas theme requires a container to render into');
  }
  function renderToolbar() {
    ReactDOM.render( /*#__PURE__*/_jsx(Toolbar, {
      editor: editor,
      toolbar: settings.canvasToolbar,
      namespace: namespace,
      inlineToolbarContainer: inlineToolbarContainer,
      showToolbarShepherd: !!editor.settings[SHOW_TOOLBAR_SHEPHERD],
      shepherdClassName: "mce-shepherd"
    }), inlineToolbarContainer);
  }
  function removeToolbar() {
    try {
      ReactDOM.unmountComponentAtNode(inlineToolbarContainer);
    } catch (e) {
      console.error(e);
    }
  }
  return {
    renderUI
  };
}
tinymce.ThemeManager.add(CANVAS_INLINE, CanvasInlineTheme);